import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProcedureMoveAppBar from "../../../common/ProcedureMoveAppBar.js";
import Snackbar from "../../../common/Snackbar.js";
import { moveSubstep } from "../../../redux/stepSlice.js";
import { copyElement } from "../../../redux/sectionSlice.js";
import { generateSHA256 } from "../../../util/generateSHA256.js";
import RenderHtml from "../../../common/AppSpecificConpnents/PartsTable/RenderHtml.js";
import {
  HeadingWithTreePath,
  generateCompleteTreePath,
} from "../../SubassemblyDetails/utils/treePathUtils.js";
import { getPages, renderPreview, renderVideo } from "../plugins/utils.js";
import {
  applyTransparency,
  calculateGroupHeight,
  calculateTextBlockWidth,
  estimateKonvaTextHeight,
  formatListContent,
  getTextStyle,
  hasNoteContent,
  hasTaskContent,
  hasUserContent,
  measureHtmlHeight,
  stripHtmlPreserveFormatting,
} from "../plugins/utils.js";
import RectangleElement from "../../Canvas/components/rectangle/RectangleElement.jsx";
import ArrowElement from "../../Canvas/components/arrow/ArrowElement.jsx";
import CircleElement from "../../Canvas/components/circle/CircleElement.jsx";
import LineElement from "../../Canvas/components/line/LineElement.jsx";
import CanvasImage from "../../Canvas/components/canvas-core/CanvasImage.jsx";
import TextElement from "../../Canvas/components/text/TextElement.jsx";
import DoubleSidedArrowElement from "../../Canvas/components/arrow/DoubleSidedArrowElement.jsx";
import CanvasDisplay from "../../Canvas/components/canvas-core/CanvasDisplay.jsx";
import {
  extractVersionStructure,
  getAuditTrailData,
} from "../../../util/getAuditTrailData.js";
import { getRevAllNodes } from "../../../redux/procedureRevisionSlice.js";
import { BASE } from "../../../config";
const ProcedureSubstepMovePreview = () => {
  const { sections } = useSelector((state) => state.section);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let richTextCounter = 1;
  let canvasCounter = 1;
  let videoCounter = 1;
  let formCounter = 1;
  let stepCounter = 1;
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [auditData, setAuditData] = useState({
    user_ref: localStorage.getItem("user_id") || "",
    ip_address: "",
    device_info: navigator.userAgent,
    hash: generateSHA256(Math.random().toString()),
    signature: "",
  });
  let richTextsCounter = {};
  let attachmentCounter = 1;
  const [isModalOpen, setModalOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });
  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);

  const [selectedView, setSelectedView] = useState("new");


  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) =>
        setAuditData((prev) => ({ ...prev, ip_address: data.ip }))
      )
      .catch((err) => console.error("Failed to fetch IP:", err));
  }, []);

  // Extract all data from location.state and add logging

  const {
    moveType,
    sourceSectionIndex,
    targetSectionIndex,
    revision,
    partNumber,
    type,
    sourceStepIndex,
    sourceSubstepIndex,
    status,
    steps,
    targetStepIndex = 0,
    targetStepId,
    targetSubstepIndex = 0,
    partId,
    revisionId,
    fromStepId,
    fromSubstepTreeId,
    fromSubstepSiblingOrder,
    targetSectionData,
    fromSectionId,
    fromSubstepId,
    fromTreeId,
    fromSiblingOrder,
    fromStepSiblingOrder,
    fromStepTreeId,
    title,
    targetNodeType,
    targetNodeIndex,
    createCopy = false,
  } = location.state;

  // Calculate sourceSubstepIndex if it's not provided
  let calculatedSourceSubstepIndex = sourceSubstepIndex;
  if (
    calculatedSourceSubstepIndex === undefined &&
    fromSubstepId &&
    fromStepId
  ) {
    const sourceSubsteps = substepsByStep[fromStepId] || [];
    calculatedSourceSubstepIndex = sourceSubsteps.findIndex(
      (s) => s.sub_step_tree_node_id === fromSubstepId
    );
  }

  // Log important data for debugging


  // Parse the substep title to get accurate step number and substep letter
  const parseSubstepInfo = (substepTitle) => {
    const match = substepTitle?.match(/^Substep (\d+)([A-Z])$/);
    if (!match) {
      console.error(
        "Could not parse substep information from title:",
        substepTitle
      );
      return {
        stepNumber: sourceStepIndex + 1,
        substepLetter: String.fromCharCode(65 + sourceSubstepIndex),
      };
    }

    const stepNumber = parseInt(match[1], 10);
    const substepLetter = match[2];

    return { stepNumber, substepLetter };
  };

  // Get the actual substep information from the title
  const { stepNumber: actualStepNumber, substepLetter: actualSubstepLetter } =
    parseSubstepInfo(title);

  const [previewSections, setPreviewSections] = useState([...sections]);
  const sortedSections = [...sections];

  const { allRevisionNodes } = useSelector((state) => state.procedureRevision);

  useEffect(() => {
    if (fromStepId) {
      dispatch(
        getRevAllNodes({
          partId: partId,
          revisionId: revisionId,
        })
      );
    }
  }, [dispatch, fromStepId, partId, revisionId]);

  useEffect(() => {
    // Create preview of the move
    const newSections = [...sections];

    if (location.state.movingSubstep) {
      // For substep moves, we'll calculate the substep positions in the render
    } else if (location.state.movingStep) {
      // For step moves, we'll calculate the step positions in the render based on the updated data
    } else {
      // Original section move logic
      const sourceSection = newSections[sourceSectionIndex];
      newSections.splice(sourceSectionIndex, 1);
      newSections.splice(targetSectionIndex, 0, sourceSection);
      setPreviewSections(newSections);
    }
  }, [
    sourceSectionIndex,
    targetSectionIndex,
    moveType,
    sourceStepIndex,
    sourceSubstepIndex,
    targetStepIndex,
    targetSubstepIndex,
    location.state.movingStep,
    location.state.movingSubstep,
    title,
  ]);

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleConfirm = () => {
    setModalOpen(true);
  };

  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };

  const handleConfirmSave = async () => {
    if (!comment.trim()) {
      showSnackbar("Please enter a comment before confirming.", "error");
      return;
    }

    setIsModalLoading(true);
    try {
      // Get source step and substep info
      const sourceStepId = fromStepId;
      const sourceSubstepId = fromSubstepId;

      // Get target section, step and substep info
      const targetSectionId =
        sortedSections[targetSectionIndex]?.section_tree_node_id;
      const targetSteps = stepsBySection[targetSectionId] || [];
      const targetStep = targetSteps[targetStepIndex] || {};

      // Use targetStepId from location.state if available, otherwise use the one from targetStep
      const finalTargetStepId = targetStepId || targetStep.step_tree_node_id;

      let targetProcedureTreeRef;

      // CRITICAL: We need to ensure the from_order and to_order are DIFFERENT
      // This is essential for the move operation to work correctly


      // Find target substep
      let finalTargetSubstepIndex = targetSubstepIndex;
      if (targetNodeType === "Substep" && targetNodeIndex !== undefined) {
        finalTargetSubstepIndex = targetNodeIndex;
      }


      // Get the target step's procedure tree ref
      targetProcedureTreeRef = targetStep.procedure_tree_ref;

      // Get target substep if applicable
      let targetSubstep = null;
      const targetSubsteps = substepsByStep[finalTargetStepId] || [];

      // For move into, the target is the step. For move up/below, the target is the substep
      let targetSubstepId = null;

      if (moveType !== "into") {
        if (
          targetSubsteps.length > finalTargetSubstepIndex &&
          finalTargetSubstepIndex >= 0
        ) {
          targetSubstep = targetSubsteps[finalTargetSubstepIndex];
          targetSubstepId = targetSubstep.sub_step_tree_node_id;
        } else {

          // Try to get it from targetSectionData as a fallback
          if (targetSectionData && targetSectionData.substepId) {
            targetSubstepId = targetSectionData.substepId;
          }
        }
      } else {
      }

      // Generate appropriate comment for audit trail
      const sourceSubstepLetter = String.fromCharCode(65 + sourceSubstepIndex);
      const targetSubstepLetter =
        moveType !== "into" ? String.fromCharCode(65 + targetSubstepIndex) : "";

      const {
        fromSection,
        fromStep,
        fromSubStep,
        toSection,
        toStep,
        toSubStep,
      } = location.state.move_rev_node_info || {};

      let actionComment = "";
      if (moveType === "into") {
        actionComment = `${createCopy ? "Copied" : "Moved"} Substep ${
          sourceStepIndex + 1
        }${sourceSubstepLetter}`;
      } else if (moveType === "up") {
        actionComment = `${createCopy ? "Copied" : "Moved"} Substep ${
          sourceStepIndex + 1
        }${sourceSubstepLetter} above Substep ${
          targetStepIndex + 1
        }${targetSubstepLetter}`;
      } else {
        actionComment = `${createCopy ? "Copied" : "Moved"} Substep ${
          sourceStepIndex + 1
        }${sourceSubstepLetter} below Substep ${
          targetStepIndex + 1
        }${targetSubstepLetter}`;
      }

      let action_to_show = `${createCopy ? "Copied" : "Moved"} ${fromSubStep} `;
      if (moveType === "into") {
        action_to_show += `from ${fromSection} > ${fromStep} into ${toSection} > ${toStep}`;
      } else if (moveType === "up") {
        action_to_show += `from ${fromSection} > ${fromStep} into ${toSection} > ${toStep} above ${toSubStep}`;
      } else {
        action_to_show += `from ${fromSection} > ${fromStep} into ${toSection} > ${toStep} below ${toSubStep}`;
      }

      // Get ACCURATE sibling order values for source substep

      // IMPORTANT: Get actual sibling order directly from the source substep
      // Find the source substep in the data
      const sourceSubsteps = substepsByStep[fromStepId] || [];

      const sourceSubstep = sourceSubsteps.find(
        (s) => s.sub_step_tree_node_id === fromSubstepId
      );

      // Parse sibling order from string to number
      // IMPORTANT: The API seems to already be using 1-indexed values
      const sourceOrderAsNumber = parseInt(
        sourceSubstep?.sibling_order ||
          sourceSubstep?.procedure_tree?.sibling_order ||
          "1",
        10
      );

      // Use the value directly since API already uses 1-indexed values
      let actualSourceSiblingOrder = sourceOrderAsNumber;


      // Default target sibling order to source + 1 for move_down/below operations
      let targetSiblingOrder = actualSourceSiblingOrder + 1;

      // Check if we're moving between different steps or sections
      const isCrossStepMove = sourceStepId !== finalTargetStepId;

      // Calculate proper from_order and to_order values based on move type
      if (isCrossStepMove) {
        // Get target substeps to calculate proper ordering
        const targetSubsteps = substepsByStep[finalTargetStepId] || [];

        // For cross-step moves, calculate the best order values
        if (moveType === "up") {
          // When moving up in a different step, calculate the exact position
          if (targetSubstepId) {
            // Find the target substep to move above
            const targetSubstep = targetSubsteps.find(
              (s) => s.sub_step_tree_node_id === targetSubstepId
            );

            if (targetSubstep) {
              // Parse the string value to a number
              const targetOrderAsNumber = parseInt(
                targetSubstep.sibling_order ||
                  targetSubstep.procedure_tree?.sibling_order ||
                  "1", // Default to position 1
                10
              );

              // Use the value directly
              targetSiblingOrder = targetOrderAsNumber;

            } else {
              // Target not found, fallback to beginning
              targetSiblingOrder = 1;
            }
          } else {
            // If no specific target, move to beginning
            targetSiblingOrder = 1;
          }
        } else if (moveType === "below" && targetSubstepId) {
          // When moving below a specific target in a different step
          const targetSubstep = targetSubsteps.find(
            (s) => s.sub_step_tree_node_id === targetSubstepId
          );

          if (targetSubstep) {
            // Parse the string value to a number
            const targetOrderAsNumber = parseInt(
              targetSubstep.sibling_order ||
                targetSubstep.procedure_tree?.sibling_order ||
                "1",
              10
            );

            // Add 1 to place it below the target
            targetSiblingOrder = targetOrderAsNumber + 1; // +1 for placing below

          } else {
            // Target not found, place at end - also adjust for 0->1 indexing
            targetSiblingOrder = Math.max(1, targetSubsteps.length + 1);
          }
        } else {
          // For move into or other cross-step moves, place at end
          targetSiblingOrder = Math.max(1, targetSubsteps.length + 1);
        }

      } else {
        // For same-step moves within the same parent
        // Get source substeps for same-step calculations
        const sourceSubsteps = substepsByStep[sourceStepId] || [];

        if (moveType === "up") {
          // When moving up within same step, calculate exact position
          if (targetSubstepId) {
            // Find the target substep to move above
            const targetSubstep = sourceSubsteps.find(
              (s) => s.sub_step_tree_node_id === targetSubstepId
            );

            if (targetSubstep) {
              // Parse the string value to a number
              const targetOrderAsNumber = parseInt(
                targetSubstep.sibling_order ||
                  targetSubstep.procedure_tree?.sibling_order ||
                  "1", // Default to position 1
                10
              );

              // Use the value directly
              targetSiblingOrder = targetOrderAsNumber;

            } else {
              // Fallback if target not found
              targetSiblingOrder = 1;
            }
          } else {
            // No specific target, move to beginning
            targetSiblingOrder = 1;
          }
        } else if (moveType === "below") {
          // For move_below operations, we need the target's position + 1
          if (targetSubstepId) {
            // Find the target substep to move below
            const targetSubstep = sourceSubsteps.find(
              (s) => s.sub_step_tree_node_id === targetSubstepId
            );

            if (targetSubstep) {
              // Get the target's position
              const targetOrder = parseInt(
                targetSubstep.sibling_order ||
                  targetSubstep.procedure_tree?.sibling_order ||
                  "1",
                10
              );

              // Set position to one after the target
              targetSiblingOrder = targetOrder + 1;


              // Special handling for moving an item below itself
              if (fromSubstepId === targetSubstepId) {
                // If moving below itself, keep the same position
                targetSiblingOrder = actualSourceSiblingOrder;
              }
            } else {
              // Target not found, use default behavior
              targetSiblingOrder = actualSourceSiblingOrder + 1;
            }
          } else {
            // No specific target, ensure to_order is larger than from_order
            targetSiblingOrder = actualSourceSiblingOrder + 1;
          }
        }

      }

      // Final check to ensure target order is at least 1
      if (targetSiblingOrder < 1) {
        targetSiblingOrder = 100; // Force a positive value starting from 1
      }

      // Also ensure source order is at least 1
      if (actualSourceSiblingOrder < 1) {
        actualSourceSiblingOrder = 1;
      }

      // Ensure the orders are different
      if (targetSiblingOrder === actualSourceSiblingOrder) {

        if (moveType === "up") {
          // For move_up/paste_up, if identical, usually want to go above/before
          if (actualSourceSiblingOrder > 1) {
            targetSiblingOrder = actualSourceSiblingOrder - 1;
          } else {
            // Can't go below 1, so move the target after instead
            targetSiblingOrder = actualSourceSiblingOrder + 1;
          }
        } else {
          // For move_down/paste_down/below/into, if identical, want to go below/after
          targetSiblingOrder = actualSourceSiblingOrder + 1;
        }

      }



      let parent_version = Object.values(substepsByStep)
        ?.flat()
        .find((step) => step.sub_step_tree_node_id === fromSubstepId);

      let newContent = structuredClone(allRevisionNodes);
      const cursection = newContent.find(
        (s) => s.section_id_ref === fromSectionId
      );
      const currentStep =
        cursection?.steps.find((s) => s.step_id_ref === fromStepId) || {};
      const currentSubStep =
        currentStep.substeps.find((s) => s.substep_id_ref === fromSubstepId) ||
        {};

      newContent = newContent.map((section) => {
        section.steps = section.steps.map((step) => {
          step.substeps = step.substeps.filter(
            (s) => s.substep_id_ref !== fromSubstepId
          );
          return step;
        });
        return section;
      });

      if (moveType === "into") {
        newContent = newContent.map((section) => {
          section.steps = section.steps.map((step) => {
            if (step.step_id_ref === targetStepId) {
              step.substeps.push(currentSubStep);
            }
            return step;
          });
          return section;
        });
      } else if (moveType === "up" || moveType === "below") {
        newContent = newContent.map((section) => {
          section.steps = section.steps.map((step) => {
            if (step.step_id_ref === targetStepId) {
              const substepIndex = step.substeps.findIndex(
                (sub) => sub.substep_id_ref === targetSectionData?.substepId
              );
              if (substepIndex !== -1) {
                if (moveType === "up" && substepIndex === 0) {
                  step.substeps.unshift(currentSubStep);
                } else {
                  step.substeps.splice(
                    moveType === "up" ? substepIndex : substepIndex + 1,
                    0,
                    currentSubStep
                  ); // insert after target
                }
              }
            }
            return step;
          });
          return section;
        });
      }

      const audit_trail_data = await getAuditTrailData(
        {
          action: "SUBSTEP_MOVED",
          comment: comment,
          parent_version: parent_version ? parent_version.version_id_ref : null,
          version_content: {
            action_to_show:
              action_to_show + ` in ${partNumber}, Rev ${revision}`,
            originingalContent: extractVersionStructure(allRevisionNodes),
            newContent: extractVersionStructure(newContent),
            moveType,
            rev: revision,
            status,
            type,
            item_code_type: type,
            partNumber,
            move_copy_action: `${toSection} > ${toStep} in ${partNumber}, Rev ${revision}`,
          },
        },
        false
      );

      // Create the payload with the calculated order values
      let substepData = {
        from_procedure_tree_node_ref: fromSubstepTreeId,
        from_order: Math.max(1, actualSourceSiblingOrder), // Ensure 1-indexed
        from_type: "substep",
        from_part_id_ref: partId,
        from_procedure_rev_ref: revisionId,
        from_section_id_ref: fromSectionId,
        from_step_id_ref: sourceStepId,
        from_substep_id_ref: sourceSubstepId,
        to_procedure_tree_node_ref: targetProcedureTreeRef,
        to_order: Math.max(1, targetSiblingOrder), // Ensure 1-indexed
        to_type: "substep",
        to_part_id_ref: partId,
        to_procedure_rev_ref: revisionId,
        to_section_id_ref: targetSectionId,
        to_step_id_ref: finalTargetStepId,
        to_substep_id_ref: moveType === "into" ? null : targetSubstepId,
        direction_move_into: moveType === "into" || isCrossStepMove,
        direction: (() => {
          switch (moveType) {
            case "up":
              return createCopy ? "paste_up" : "move_up";
            case "below":
            case "down":
              return createCopy ? "paste_down" : "move_down";
            case "into":
              return createCopy ? "paste_down" : "move_down";
            default:
              return createCopy ? "paste_down" : "move_down"; // Default fallback
          }
        })(),
        audit_trail_data,
      };

      // CRITICAL DEBUGGING: Log detailed information about substep counts and order values

      // FINAL VALIDATION: Ensure values are valid integers within reasonable ranges

      // Convert to integers (not just numbers)
      substepData.from_order = parseInt(substepData.from_order, 10);
      substepData.to_order = parseInt(substepData.to_order, 10);

      // Make sure we don't send NaN or non-integer values
      if (
        isNaN(substepData.from_order) ||
        !Number.isInteger(substepData.from_order)
      ) {
        substepData.from_order = 1;
      }

      if (
        isNaN(substepData.to_order) ||
        !Number.isInteger(substepData.to_order)
      ) {
        substepData.to_order = substepData.from_order !== 1 ? 1 : 2;
      }

      // Get the source and target substep lists to determine reasonable maximum values
      const allSourceSubsteps = substepsByStep[fromStepId] || [];
      const allTargetSubsteps = substepsByStep[finalTargetStepId] || [];

      // Calculate reasonable maximum values based on the number of substeps
      let maxSourceOrder = Math.max(allSourceSubsteps.length, 1);
      let maxTargetOrder = Math.max(allTargetSubsteps.length, 1);

      // Enforce reasonable limits on the values
      if (substepData.from_order > maxSourceOrder) {
        substepData.from_order = maxSourceOrder;
      }

      if (substepData.to_order > maxTargetOrder + 1) {
        // +1 to allow appending at the end
        substepData.to_order = maxTargetOrder + 1;
      }

      // Final bounds check - absolute max values as a safety measure
      if (substepData.from_order > 100) substepData.from_order = 100;
      if (substepData.to_order > 100) substepData.to_order = 100;

      // Critical check - ensure minimum values
      if (substepData.from_order < 1) substepData.from_order = 1;
      if (substepData.to_order < 1) substepData.to_order = 1;

      // Critical check - ensure from_order and to_order are never the same
      if (substepData.from_order === substepData.to_order) {

        // Only change the target order if absolutely necessary
        if (moveType === "up") {
          // When moving a higher-ordered item (e.g., 4) up to a lower position (e.g., 2)
          // we should NOT force to_order < from_order, as that would break the logic
          // For a move_up/paste_up operation, to_order can be > from_order when moving DOWN the list

          // Only adjust if the target was not explicitly set
          if (targetSubstepId === null) {
            // If no specific target was set, default to 1
            substepData.to_order = 1;
          } else {
            // If a target was specified but orders are identical, adjust by ±1
            if (substepData.from_order > 1) {
              // If possible, reduce to_order by 1
              substepData.to_order = substepData.from_order - 1;
            } else {
              // If at position 1, increment to_order
              substepData.to_order = substepData.from_order + 1;
            }
          }
        } else {
          // For other moves, ensure to_order is greater than from_order
          substepData.to_order = substepData.from_order + 1;
        }

      }


      // Replace with stricter validation:
      // Get the exact counts of substeps in source and target steps
      const exactSourceSubsteps = substepsByStep[fromStepId] || [];
      const exactTargetSubsteps = substepsByStep[finalTargetStepId] || [];

      let exactSourceCount = exactSourceSubsteps.length;
      let exactTargetCount = exactTargetSubsteps.length;


      // CRITICAL: NEVER allow from_order to exceed the number of source substeps
      if (substepData.from_order > exactSourceCount) {
        substepData.from_order = exactSourceCount;
      }

      // For to_order, we can go up to count+1 (to append at the end)
      // But NEVER beyond that
      if (substepData.to_order > exactTargetCount + 1) {
        substepData.to_order = exactTargetCount + 1;
      }

      // Extra validation for move_below to the end of the list
      if (moveType === "below" && !targetSubstepId) {
        // When moving below without a specific target, it means "move to the end"
        substepData.to_order = exactTargetCount + 1;
      }

      // Add final validation before dispatch:
      // Extra validation for move_below to the end of the list
      if (moveType === "below" && !targetSubstepId) {
        // When moving below without a specific target, it means "move to the end"
        substepData.to_order = exactTargetCount + 1;
      }

      // FINAL SAFETY CHECK: Hard cap order values to prevent any possibility of exceeding counts
      // This is our last line of defense before sending the payload
      let substepCountInSource = (substepsByStep[fromStepId] || []).length;
      let substepCountInTarget = (substepsByStep[finalTargetStepId] || [])
        .length;

      // Final check that from_order is within bounds
      if (substepData.from_order > substepCountInSource) {
        substepData.from_order = substepCountInSource;
      }

      // Final check that to_order is within bounds (allowing count+1 for appending)
      if (substepData.to_order > substepCountInTarget + 1) {
        substepData.to_order = substepCountInTarget + 1;
      }


      // EMERGENCY FIX FOR to_order EXCEEDING COUNT
      // Get the absolute latest count of substeps in the target step
      let finalCheckTargetSubsteps = substepsByStep[finalTargetStepId] || [];
      let absoluteMaxToOrder = finalCheckTargetSubsteps.length;

      // Allow append at end (count+1) for below operations
      const isAppendAtEnd = moveType === "below" && !targetSubstepId;
      let maxAllowedToOrder = isAppendAtEnd
        ? absoluteMaxToOrder + 1
        : absoluteMaxToOrder;

      // EMERGENCY FIX: Ensure to_order does not exceed maximum allowed value
      if (substepData.to_order > maxAllowedToOrder) {
        // Force to_order to be no greater than the allowed maximum
        substepData.to_order = maxAllowedToOrder;
      }

      // Double-check from_order as well
      let finalCheckSourceSubsteps = substepsByStep[fromStepId] || [];
      let absoluteMaxFromOrder = finalCheckSourceSubsteps.length;
      if (substepData.from_order > absoluteMaxFromOrder) {
        substepData.from_order = absoluteMaxFromOrder;
      }


      if (moveType === "into") {
        // Get all items in the target container
        let targetItems = [];
        // Get the target element's container ID
        const targetContainerId =
          targetSectionData?.substepId || targetSectionData?.stepId;
        if (targetSectionData?.substepId) {
          // If target is a substep, get all items in that substep
          targetItems = [
            ...(richTexts[targetContainerId] || []),
            ...(forms[targetContainerId] || []),
            ...(attachments[targetContainerId] || []),
            ...(canvases[targetContainerId] || []),
            ...(videos[targetContainerId] || []),
            ...(substepsByStep[targetContainerId] || []),
          ];
        } else if (targetSectionData?.stepId) {
          // If target is a step, get all items in that step (excluding substep items)
          const allStepItems = [
            ...(richTexts[targetContainerId] || []),
            ...(forms[targetContainerId] || []),
            ...(attachments[targetContainerId] || []),
            ...(canvases[targetContainerId] || []),
            ...(videos[targetContainerId] || []),
            ...(substepsByStep[targetContainerId] || []),
          ];
          targetItems = allStepItems;
        }

        let highestOrder = 0;
        targetItems.forEach((item) => {
          const order = parseInt(
            item.sibling_order || item.procedure_tree?.sibling_order || 0
          );
          if (!isNaN(order) && order > highestOrder) {
            highestOrder = order;
          }
        });
        substepData.to_order = highestOrder + 1;
      }

      if (moveType === "below" || moveType === "down") {
        substepData.to_order = Math.max(1, substepData.to_order) + 1;
      }
      try {
        // Create payload based on operation type
        const payload = {
          ...substepData,
          ...(createCopy ? {} : { create_copy: createCopy }), // Only add create_copy for move operations
        };

        // Now dispatch with the validated payload
        if (createCopy) {
          // Use copyElement action for copy operations
          await dispatch(copyElement(payload)).unwrap();
        } else {
          // Use moveSubstep action for move operations
          await dispatch(moveSubstep(payload)).unwrap();
        }
      } catch (error) {
        console.error("Error moving substep:", error);
        showSnackbar("Error moving substep: " + error.message, "error");
      }

      showSnackbar(
        createCopy
          ? "Substep copied successfully!"
          : "Substep moved successfully!",
        "success"
      );
      setModalOpen(false);
      navigate(-3); // Navigate back to the previous page
    } catch (error) {
      console.error("Error during move operation:", error);
      showSnackbar("Error during move operation: " + error.message, "error");
    } finally {
      setIsModalLoading(false);
    }
  };

  const getReorderedSubsteps = (
    substepsByStep,
    sourceSectionIndex,
    targetSectionIndex,
    sourceStepIndex,
    targetStepIndex,
    sourceSubstepIndex,
    targetSubstepIndex,
    moveType,
    movingSubstep = false,
    createCopy = false
  ) => {
    if (selectedView === "original" || !movingSubstep) {
      return substepsByStep;
    }

    const updatedSubstepsByStep = JSON.parse(JSON.stringify(substepsByStep));

    const sourceStepId = fromStepId || steps[0]?.procedure_tree?.step_id_ref;


    let finalTargetStepId = targetStepId;
    if (!finalTargetStepId) {
      const targetSectionId =
        sortedSections[targetSectionIndex]?.section_tree_node_id;
      const targetSteps = stepsBySection[targetSectionId] || [];
      const targetStep = targetSteps[targetStepIndex] || {};
      finalTargetStepId = targetStep.step_tree_node_id;
    }


    if (!sourceStepId || !finalTargetStepId) return updatedSubstepsByStep;

    const sourceSubsteps = [...(updatedSubstepsByStep[sourceStepId] || [])];

    if (sourceSubstepIndex >= sourceSubsteps.length)
      return updatedSubstepsByStep;

    const substepToMove = sourceSubsteps[sourceSubstepIndex];

    if (createCopy) {

      // Create a copy of the substep and insert it at the calculated position
      const newSubstepId = `${
        substepToMove.sub_step_tree_node_id
      }_copy_${Date.now()}`;
      const substepCopy = {
        ...substepToMove,
        sub_step_tree_node_id: newSubstepId,
        sibling_order: targetSubstepIndex + 1,
      };

      let targetSubsteps = [
        ...(updatedSubstepsByStep[finalTargetStepId] || []),
      ];

      let insertionIndex = targetSubstepIndex;
      if (moveType === "into") {
        insertionIndex = targetSubsteps.length;
      } else if (moveType === "up") {
        insertionIndex = targetSubstepIndex;
      } else if (moveType === "below") {
        insertionIndex = targetSubstepIndex + 1;
      }

      insertionIndex = Math.max(
        0,
        Math.min(insertionIndex, targetSubsteps.length)
      );
      targetSubsteps.splice(insertionIndex, 0, substepCopy);

      // Update sibling orders of all substeps after the insertion point
      targetSubsteps.forEach((substep, idx) => {
        if (idx > insertionIndex) {
          substep.sibling_order = idx + 1;
          if (substep.procedure_tree) {
            substep.procedure_tree.sibling_order = idx + 1;
          }
        }
      });

      // Copy all child elements associated with the original substep
      const originalSubstepId = substepToMove.sub_step_tree_node_id;

      // Copy substep rich texts
      if (richTexts[originalSubstepId]) {
        richTexts[originalSubstepId].forEach((richText) => {
          const newRichTextId = `${
            richText.rich_text_tree_node_id
          }_copy_${Date.now()}`;
          const richTextCopy = {
            ...richText,
            rich_text_tree_node_id: newRichTextId,
            sub_step_tree_node_id: newSubstepId,
          };
          if (
            !updatedSubstepsByStep[finalTargetStepId + "_substep_richTexts"]
          ) {
            updatedSubstepsByStep[finalTargetStepId + "_substep_richTexts"] =
              {};
          }
          if (
            !updatedSubstepsByStep[finalTargetStepId + "_substep_richTexts"][
              newSubstepId
            ]
          ) {
            updatedSubstepsByStep[finalTargetStepId + "_substep_richTexts"][
              newSubstepId
            ] = [];
          }
          updatedSubstepsByStep[finalTargetStepId + "_substep_richTexts"][
            newSubstepId
          ].push(richTextCopy);
        });
      }

      // Copy substep forms
      if (forms[originalSubstepId]) {
        forms[originalSubstepId].forEach((form) => {
          const newFormId = `${form.form_tree_node_id}_copy_${Date.now()}`;
          const formCopy = {
            ...form,
            form_tree_node_id: newFormId,
            sub_step_tree_node_id: newSubstepId,
          };
          if (!updatedSubstepsByStep[finalTargetStepId + "_substep_forms"]) {
            updatedSubstepsByStep[finalTargetStepId + "_substep_forms"] = {};
          }
          if (
            !updatedSubstepsByStep[finalTargetStepId + "_substep_forms"][
              newSubstepId
            ]
          ) {
            updatedSubstepsByStep[finalTargetStepId + "_substep_forms"][
              newSubstepId
            ] = [];
          }
          updatedSubstepsByStep[finalTargetStepId + "_substep_forms"][
            newSubstepId
          ].push(formCopy);
        });
      }

      // Copy substep attachments
      if (attachments[originalSubstepId]) {
        attachments[originalSubstepId].forEach((attachment) => {
          const newAttachmentId = `${
            attachment.attachment_tree_node_id
          }_copy_${Date.now()}`;
          const attachmentCopy = {
            ...attachment,
            attachment_tree_node_id: newAttachmentId,
            sub_step_tree_node_id: newSubstepId,
          };
          if (
            !updatedSubstepsByStep[finalTargetStepId + "_substep_attachments"]
          ) {
            updatedSubstepsByStep[finalTargetStepId + "_substep_attachments"] =
              {};
          }
          if (
            !updatedSubstepsByStep[finalTargetStepId + "_substep_attachments"][
              newSubstepId
            ]
          ) {
            updatedSubstepsByStep[finalTargetStepId + "_substep_attachments"][
              newSubstepId
            ] = [];
          }
          updatedSubstepsByStep[finalTargetStepId + "_substep_attachments"][
            newSubstepId
          ].push(attachmentCopy);
        });
      }

      // Copy substep canvases
      if (canvases[originalSubstepId]) {
        canvases[originalSubstepId].forEach((canvas) => {
          const newCanvasId = `${
            canvas.canvas_tree_node_id
          }_copy_${Date.now()}`;
          const canvasCopy = {
            ...canvas,
            canvas_tree_node_id: newCanvasId,
            sub_step_tree_node_id: newSubstepId,
          };
          if (!updatedSubstepsByStep[finalTargetStepId + "_substep_canvases"]) {
            updatedSubstepsByStep[finalTargetStepId + "_substep_canvases"] = {};
          }
          if (
            !updatedSubstepsByStep[finalTargetStepId + "_substep_canvases"][
              newSubstepId
            ]
          ) {
            updatedSubstepsByStep[finalTargetStepId + "_substep_canvases"][
              newSubstepId
            ] = [];
          }
          updatedSubstepsByStep[finalTargetStepId + "_substep_canvases"][
            newSubstepId
          ].push(canvasCopy);
        });
      }

      // Copy substep videos
      if (videos[originalSubstepId]) {
        videos[originalSubstepId].forEach((video) => {
          const newVideoId = `${video.video_tree_node_id}_copy_${Date.now()}`;
          const videoCopy = {
            ...video,
            video_tree_node_id: newVideoId,
            sub_step_tree_node_id: newSubstepId,
          };
          if (!updatedSubstepsByStep[finalTargetStepId + "_substep_videos"]) {
            updatedSubstepsByStep[finalTargetStepId + "_substep_videos"] = {};
          }
          if (
            !updatedSubstepsByStep[finalTargetStepId + "_substep_videos"][
              newSubstepId
            ]
          ) {
            updatedSubstepsByStep[finalTargetStepId + "_substep_videos"][
              newSubstepId
            ] = [];
          }
          updatedSubstepsByStep[finalTargetStepId + "_substep_videos"][
            newSubstepId
          ].push(videoCopy);
        });
      }

      updatedSubstepsByStep[finalTargetStepId] = targetSubsteps;


      return updatedSubstepsByStep;
    }

    // Original move logic
    const [movedSubstep] = sourceSubsteps.splice(sourceSubstepIndex, 1);

    let targetSubsteps =
      sourceStepId === finalTargetStepId
        ? sourceSubsteps
        : [...(updatedSubstepsByStep[finalTargetStepId] || [])];

    let insertionIndex = targetSubstepIndex;

    if (moveType === "into") {
      insertionIndex = targetSubsteps.length; // Move to end
    } else if (moveType === "up") {
      if (
        sourceStepId === finalTargetStepId &&
        sourceSubstepIndex < targetSubstepIndex
      ) {
        insertionIndex = targetSubstepIndex - 1;
      } else {
        insertionIndex = targetSubstepIndex;
      }
    } else if (moveType === "below") {
      // For "below" operations, always insert AFTER the target
      if (
        sourceStepId === finalTargetStepId &&
        sourceSubstepIndex < targetSubstepIndex
      ) {
        // When moving within same step and source is before target,
        // the target index shifts down by 1 after removing the source
        // But we want to insert AFTER the target, so we use targetSubstepIndex
        insertionIndex = targetSubstepIndex; // Insert at the original target position
      } else {
        insertionIndex = targetSubstepIndex + 1; // Insert after target
      }
    }


    // Ensure insertionIndex is within bounds
    insertionIndex = Math.max(
      0,
      Math.min(insertionIndex, targetSubsteps.length)
    );

    targetSubsteps.splice(insertionIndex, 0, movedSubstep);

    updatedSubstepsByStep[sourceStepId] = sourceSubsteps;
    if (sourceStepId !== finalTargetStepId) {
      updatedSubstepsByStep[finalTargetStepId] = targetSubsteps;
    }

    return updatedSubstepsByStep;
  };

  const getReorderedStepsBySection = (
    stepsBySection,
    sortedSections,
    sourceSectionIndex,
    targetSectionIndex,
    sourceStepIndex,
    targetStepIndex,
    moveType,
    movingStep = false,
    movingSubstep = false
  ) => {
    if (selectedView === "original") return stepsBySection;
    if (movingSubstep) return stepsBySection; // For substep moves, we don't reorder steps

    // Clone the existing structure to avoid mutating state directly
    const updatedStepsBySection = JSON.parse(JSON.stringify(stepsBySection));

    if (movingStep) {
      // Get the source section ID
      const sourceSectionId = sortedSections.find(
        (s) => s.section_tree_node_id === sourceSectionIndex
      )?.section_tree_node_id;
      if (!sourceSectionId) return updatedStepsBySection;

      // Get the target section ID
      const targetSectionId =
        sortedSections[targetSectionIndex].section_tree_node_id;

      // Get the source steps array and the step to move
      const sourceSteps = [...(updatedStepsBySection[sourceSectionId] || [])];
      if (sourceStepIndex >= sourceSteps.length) return updatedStepsBySection;

      // Remove step from source
      const [movedStep] = sourceSteps.splice(sourceStepIndex, 1);

      // Get the target steps array
      const targetSteps = [...(updatedStepsBySection[targetSectionId] || [])];

      // Handle different move types
      if (moveType === "into") {
        // Move to end of target section
        targetSteps.push(movedStep);
      } else if (moveType === "up") {
        // Insert before the target step
        targetSteps.splice(targetStepIndex, 0, movedStep);
      } else if (moveType === "below") {
        // Insert after the target step
        targetSteps.splice(targetStepIndex + 1, 0, movedStep);
      }

      // Update the mappings
      updatedStepsBySection[sourceSectionId] = sourceSteps;
      updatedStepsBySection[targetSectionId] = targetSteps;
    }

    return updatedStepsBySection;
  };

  const updated = getReorderedStepsBySection(
    stepsBySection,
    sections,
    sourceSectionIndex,
    targetSectionIndex,
    sourceStepIndex,
    targetStepIndex,
    moveType,
    location.state.movingStep,
    location.state.movingSubstep
  );


  const updatedSubsteps = location.state.movingSubstep
    ? getReorderedSubsteps(
        substepsByStep,
        sourceSectionIndex,
        targetSectionIndex,
        sourceStepIndex,
        targetStepIndex,
        calculatedSourceSubstepIndex,
        targetSubstepIndex,
        moveType,
        location.state.movingSubstep,
        createCopy
      )
    : substepsByStep;


  // Debug specific step that should have reordered substeps
  if (location.state.movingSubstep && fromStepId) {
  }

  // Helper function to get child elements (considering copied elements)
  const getChildElements = (stepId, sectionId, elementType) => {
    // Ensure stepId and sectionId are valid
    if (!stepId || !sectionId) {
      return [];
    }

    // First check if we have copied elements for this step
    const copiedElements = updated[sectionId + "_" + elementType]?.[stepId];
    if (copiedElements && Array.isArray(copiedElements)) {
      return copiedElements;
    }

    // Fallback to original Redux state
    switch (elementType) {
      case "richTexts":
        return richTexts && richTexts[stepId] ? richTexts[stepId] : [];
      case "forms":
        return forms && forms[stepId] ? forms[stepId] : [];
      case "attachments":
        return attachments && attachments[stepId] ? attachments[stepId] : [];
      case "canvases":
        return canvases && canvases[stepId] ? canvases[stepId] : [];
      case "videos":
        return videos && videos[stepId] ? videos[stepId] : [];
      case "substeps":
        return substepsByStep && substepsByStep[stepId]
          ? substepsByStep[stepId]
          : [];
      default:
        return [];
    }
  };

  // Helper function to get substep child elements (considering copied elements)
  const getSubstepChildElements = (substepId, stepId, elementType) => {
    // Ensure substepId and stepId are valid
    if (!substepId || !stepId) {
      return [];
    }

    // First check if we have copied substep elements inside the updatedSubsteps structure
    const copiedElements =
      updatedSubsteps[stepId + "_substep_" + elementType]?.[substepId];
    if (copiedElements && Array.isArray(copiedElements)) {
      return copiedElements;
    }

    // Fallback to original Redux state
    switch (elementType) {
      case "richTexts":
        return richTexts && richTexts[substepId] ? richTexts[substepId] : [];
      case "forms":
        return forms && forms[substepId] ? forms[substepId] : [];
      case "attachments":
        return attachments && attachments[substepId]
          ? attachments[substepId]
          : [];
      case "canvases":
        return canvases && canvases[substepId] ? canvases[substepId] : [];
      case "videos":
        return videos && videos[substepId] ? videos[substepId] : [];
      default:
        return [];
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Main Page Loader */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div
              style={{
                border: "4px solid #f3f3f3",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                animation: "spin 1s linear infinite",
                marginBottom: "10px",
              }}
            ></div>
            <div style={{ fontSize: "16px", color: "#333" }}>
              Moving substep...
            </div>
          </div>
        </div>
      )}
      <ProcedureMoveAppBar
        selectedView={selectedView}
        showBackButton={false}
        setSelectedView={setSelectedView}
        title={
          createCopy
            ? "Please Confirm the Changes"
            : "Please Confirm the Changes"
        }
        buttons={[{ label: "Confirm", onClick: handleConfirm }]}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "8px 20px",
          flexWrap: "wrap", // for responsiveness
        }}
      >
        {/* Checkbox + Title + Description */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              margin: 0,
            }}
          >
            {/* <input type="checkbox" disabled={true} checked={false} /> */}
            <span style={{ fontSize: "20px", fontWeight: 600 }}>
              {type} {partNumber}
            </span>
          </label>

          {/* Description */}
        </div>

        {/* Right-aligned section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginLeft: "auto",
          }}
        >
          <div>
            <strong>Status: </strong>
            <span style={{ color: "orange" }}>Not Submitted</span>
            {/* <span style={{ color: "orange" }}>{status}</span> */}
          </div>

          <div>
            <strong>Revision: </strong>
            <span>{revision}</span>
          </div>
        </div>
      </div>
      <div style={{ padding: "20px" }}>
        <div style={{ marginTop: "20px" }}>
          {sections.map((section, index) => {
            return (
              <div
                key={section.section_tree_node_id}
                style={{
                  margin: "20px 0",
                  clear: "both",
                }}
              >
                {/* Simple heading for sections without tree path */}
                <h2 style={{ fontSize: "20px", margin: 0, color: "#000" }}>
                  Section {index + 1}
                </h2>
                <hr />
                <hr />
                <div>{section.section_name}</div>
                <div>{section.short_description}</div>

                {/* Steps for this section */}
                {(updated[section.section_tree_node_id] || []).map(
                  (step, stepIndex) => {
                    const stepId = step.step_tree_node_id;
                    const sectionId = section.section_tree_node_id;
                    stepCounter++;
                    const stepsBeforeThisSection = previewSections
                      .slice(0, index)
                      .reduce(
                        (acc, s) =>
                          acc + (updated[s.section_tree_node_id]?.length || 0),
                        0
                      );
                    const globalStepNumber =
                      stepsBeforeThisSection + stepIndex + 1;

                    const substeps = substepsByStep[stepId] || [];

                    const substepLetter = String.fromCharCode(
                      65 + substeps.length
                    ); // A, B, C...

                    // Calculate media counters before navigation
                    const currentAttachmentCounter = attachmentCounter;
                    const currentVideoCounter = videoCounter;
                    const currentFormCounter = formCounter;
                    const currentCanvasCounter = canvasCounter;
                    const currentRichTextCounter = richTextCounter;

                    // Update counters for next step
                    //attachmentCounter += myAttachments.length;
                    // videoCounter += myVideos.length;
                    // formCounter += myForms.length;
                    // canvasCounter += myCanvases.length;
                    // richTextCounter += myRichTexts.length; // If you're adding one richText per step

                    richTextsCounter[stepId] = currentRichTextCounter;

                    const combinedItems = [
                      ...(
                        getChildElements(stepId, sectionId, "richTexts") || []
                      ).map((item) => ({
                        ...item,
                        type: "richText",
                      })),
                      ...(
                        getChildElements(stepId, sectionId, "forms") || []
                      ).map((item) => ({
                        ...item,
                        type: "form",
                      })),
                      ...(
                        getChildElements(stepId, sectionId, "attachments") || []
                      ).map((item) => ({
                        ...item,
                        type: "attachment",
                      })),
                      ...(
                        getChildElements(stepId, sectionId, "canvases") || []
                      ).map((item) => ({
                        ...item,
                        type: "canvas",
                      })),
                      ...(
                        getChildElements(stepId, sectionId, "videos") || []
                      ).map((item) => ({
                        ...item,
                        type: "video",
                      })),
                    ]; // Filter out substeps or unwanted items (same as your current filter)
                    const filteredItems = combinedItems.filter(
                      (item) =>
                        item &&
                        !item.substep_id_ref &&
                        !item.sub_step_tree_node_id
                    );

                    filteredItems.sort((a, b) => {
                      if (!a || !b) return 0;

                      const orderA =
                        a.sibling_order || a.procedure_tree?.sibling_order;
                      const orderB =
                        b.sibling_order || b.procedure_tree?.sibling_order;

                      const orderCompare = compareSiblingOrders(orderA, orderB);
                      if (orderCompare !== 0) return orderCompare;

                      // Fallback: compare created_at
                      const dateA = new Date(a.created_at || 0);
                      const dateB = new Date(b.created_at || 0);
                      return dateB - dateA; // latest comes first
                    });
                    const allChildrenUnderStep = [
                      ...(getChildElements(stepId, sectionId, "richTexts") ||
                        []),
                      ...(getChildElements(stepId, sectionId, "forms") || []),
                      ...(getChildElements(stepId, sectionId, "attachments") ||
                        []),
                      ...(getChildElements(stepId, sectionId, "canvases") ||
                        []),
                      ...(getChildElements(stepId, sectionId, "videos") || []),
                      // Also optionally substeps, if they have sibling_order
                    ];

                    return (
                      <div
                        key={stepId}
                        style={{ marginTop: "20px", clear: "both" }}
                      >
                        <HeadingWithTreePath
                          title={`Step ${globalStepNumber}`}
                          treePathParams={{
                            sectionIndex: index,
                            stepIndex: globalStepNumber - 1,
                            substepIndex: undefined,
                            nodeType: undefined,
                            nodeIndex: undefined,
                          }}
                        />
                        <hr />
                        <p style={{ whiteSpace: 'pre-wrap' }}>{step.short_description || ""}</p>
                        <p>
                          <p>
                            {structuredClone(step.step_details)
                              .sort(
                                (a, b) =>
                                  new Date(a.created_at) -
                                  new Date(b.created_at)
                              )
                              .map((myStep) => {
                                const partNumber =
                                  myStep.part_info?.part_number || "";
                                const description =
                                  myStep.part_info?.description || "";
                                const qtyText =
                                  myStep.qty && myStep.qty != 0
                                    ? `Qty ${myStep.qty}`
                                    : "";

                                const partText = partNumber
                                  ? ` (${partNumber})`
                                  : "";

                                return (
                                  <>
                                    {myStep.action}
                                    {partText}{" "}
                                    <RenderHtml content={description} />{" "}
                                    {qtyText}&nbsp;
                                  </>
                                );
                              })}
                          </p>
                        </p>

                        <h4>
                          {step.bom_table_title_info?.category_name || ""}
                        </h4>

                        <table className="table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>
                                {
                                  step.part_number_column_title_ref_info
                                    ?.category_name
                                }{" "}
                              </th>
                              <th>Description</th>
                              <th>Qty Per</th>
                              <th>Unit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {step.parts_required.map((row) => (
                              <tr>
                                <td>{row.part_info.type_info.name}</td>
                                <td>{row.part_info.part_number}</td>
                                <td>
                                  <RenderHtml
                                    content={row.part_info.description}
                                  />{" "}
                                </td>
                                <td>{row.qty === 0 ? "" : row.qty}</td>
                                <td>{row.part_info?.unit_info?.unit_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Step Content */}

                        {filteredItems.map((item, itemIndex) => {
                          if (item.substep_id_ref || item.sub_step_tree_node_id)
                            return null;
                          switch (item.type) {
                            case "richText": {
                              const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                              // render richText block here
                              const label = (
                                <HeadingWithTreePath
                                  title={`Rich Text ${globalRichTextNumber}`}
                                  treePathParams={{
                                    sectionIndex: index,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "richText",
                                    nodeIndex: globalRichTextNumber - 1,
                                  }}
                                />
                              );

                              return (
                                <div
                                  key={item.rich_text_tree_node_id}
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      marginLeft: "5px",
                                      marginTop: "-10px",
                                    }}
                                  >
                                    {item.short_description}
                                  </div>
                                  {item.category_data && (
                                    <div
                                      style={{
                                        marginLeft: "4px",
                                        marginTop: "10px",
                                        clear: "both",
                                      }}
                                    >
                                      {item.category_data.category_name}
                                    </div>
                                  )}
                                  <div
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                      clear: "both",
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginTop: "-6px",
                                        clear: "both",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: item.rich_text_content,
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            }
                            case "video": {
                              const globalVideoNumber = videoCounter++; // ✅ use then increment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Video ${globalVideoNumber}`}
                                  treePathParams={{
                                    sectionIndex: index,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "video",
                                    nodeIndex: globalVideoNumber - 1,
                                  }}
                                />
                              );

                              return (
                                <div
                                  key={label}
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <video
                                    src={`${
                                      item.video && item.video.includes("http")
                                        ? item.video
                                        : `${BASE}${item.video}`
                                    }`}
                                    controls
                                    style={{
                                      width: "100%",
                                      maxHeight: "360px",
                                      borderRadius: "6px",
                                      backgroundColor: "#000",
                                      clear: "both",
                                    }}
                                  />

                                  <div>{item.video_url || ""}</div>

                                  <div>{item.short_description || ""}</div>
                                </div>
                              );
                            }

                            case "form": {
                              const globalFormNumber = formCounter++; // ✅ use then increment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Form ${globalFormNumber}`}
                                  treePathParams={{
                                    sectionIndex: index,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "form",
                                    nodeIndex: globalFormNumber - 1,
                                  }}
                                />
                              );
                              // render form block here
                              return (
                                <div key={label}>
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>
                                  <div>{item.short_description || ""}</div>
                                </div>
                              );
                            }
                            case "canvas": {
                              const pages = getPages(item);

                              const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Canvas ${globalCanvasNumber}`}
                                  treePathParams={{
                                    sectionIndex: index,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "canvas",
                                    nodeIndex: globalCanvasNumber - 1,
                                  }}
                                />
                              );
                              const shapes = item.shapes || [];

                              return (
                                <div
                                  key={label}
                                  style={{ marginTop: "40px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div>{item.short_description || ""}</div>

                                  {/* Display all pages vertically */}
                                  <CanvasDisplay pages={pages} />
                                </div>
                              );
                            }
                            case "attachment": {
                              const attachmentList = item.attachments || [];
                              if (attachmentList.length === 0) return null;

                              //  const globalAttachmentNumber =
                              //           attachmentCounter++; // ✅ use then increment
                              const globalAttachmentNumber =
                                attachmentCounter++; // ✅ Increment here per attachment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Attachment ${globalAttachmentNumber}`}
                                  treePathParams={{
                                    sectionIndex: index,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "attachment",
                                    nodeIndex: globalAttachmentNumber - 1,
                                  }}
                                />
                              );

                              return (
                                <div key={item} style={{ clear: "both" }}>
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>
                                  <div>{item.short_description || ""}</div>
                                  {attachmentList.map((attachment, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        marginLeft: "20px",
                                        clear: "both",
                                      }}
                                    >
                                      {renderPreview(attachment)}
                                    </div>
                                  ))}
                                </div>
                              );
                            }
                            default:
                              return null;
                          }
                        })}

                        {/* Substeps */}
                        {(() => {
                          const substepsToRender =
                            updatedSubsteps[stepId] || [];
                          return substepsToRender;
                        })().map((substep, substepIndex) => {
                          const substepId = substep.sub_step_tree_node_id;
                          const combinedItems = [
                            ...(
                              getSubstepChildElements(
                                substepId,
                                stepId,
                                "richTexts"
                              ) || []
                            ).map((item) => ({
                              ...item,
                              type: "richText",
                            })),
                            ...(
                              getSubstepChildElements(
                                substepId,
                                stepId,
                                "forms"
                              ) || []
                            ).map((item) => ({
                              ...item,
                              type: "form",
                            })),
                            ...(
                              getSubstepChildElements(
                                substepId,
                                stepId,
                                "attachments"
                              ) || []
                            ).map((item) => ({
                              ...item,
                              type: "attachment",
                            })),
                            ...(
                              getSubstepChildElements(
                                substepId,
                                stepId,
                                "canvases"
                              ) || []
                            ).map((item) => ({
                              ...item,
                              type: "canvas",
                            })),
                            ...(
                              getSubstepChildElements(
                                substepId,
                                stepId,
                                "videos"
                              ) || []
                            ).map((item) => ({
                              ...item,
                              type: "video",
                            })),
                          ]; // Filter out substeps or unwanted items (same as your current filter)
                          const filteredItems = combinedItems;

                          filteredItems.sort((a, b) => {
                            if (!a || !b) return 0;

                            const orderA =
                              a.sibling_order ||
                              a.procedure_tree?.sibling_order;
                            const orderB =
                              b.sibling_order ||
                              b.procedure_tree?.sibling_order;

                            const orderCompare = compareSiblingOrders(
                              orderA,
                              orderB
                            );
                            if (orderCompare !== 0) return orderCompare;

                            // Fallback: compare created_at
                            const dateA = new Date(a.created_at || 0);
                            const dateB = new Date(b.created_at || 0);
                            return dateB - dateA; // latest comes first
                          });

                          // Global step number calculation based on the updated steps data
                          const stepsBeforeThisOne =
                            previewSections
                              .slice(0, index)
                              .reduce((sectionAcc, s) => {
                                const steps =
                                  updated[s.section_tree_node_id] || [];
                                return sectionAcc + steps.length;
                              }, 0) + stepIndex;

                          const globalStepNumber = stepsBeforeThisOne + 1;

                          // Final substep label like Substep 5A
                          const substepLetter = String.fromCharCode(
                            65 + substepIndex
                          ); // A, B, C, ...

                          const globalSubstepLabel = `Substep ${globalStepNumber}${substepLetter}`;

                          const globalRichTextNumber = richTextCounter; // ✅ use then increment
                          const globalAttachmentNumber = attachmentCounter;
                          const globalVideoNumber = videoCounter;
                          const globalCanvasNumber = canvasCounter;
                          const globalFormNumber = formCounter;

                          // Store the section index to use in the inner loop
                          const currentSectionIndex = index;

                          // Add highlight for moved substep
                          const isSourceSubstep =
                            location.state.movingSubstep &&
                            steps[0]?.sub_step_tree_node_id ===
                              substep.sub_step_tree_node_id;
                          const isTargetPosition =
                            location.state.movingSubstep &&
                            section.section_tree_node_id ===
                              sortedSections[targetSectionIndex]
                                ?.section_tree_node_id &&
                            stepIndex === location.state.targetStepIndex &&
                            ((moveType === "up" &&
                              substepIndex ===
                                location.state.targetSubstepIndex) ||
                              (moveType === "below" &&
                                substepIndex ===
                                  location.state.targetSubstepIndex + 1) ||
                              (moveType === "into" &&
                                substepIndex ===
                                  (updatedSubsteps[stepId] || []).length - 1));

                          return (
                            <div
                              key={substepId}
                              style={{ marginTop: "20px", clear: "both" }}
                            >
                              <div>
                                <HeadingWithTreePath
                                  title={globalSubstepLabel}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: substepIndex,
                                    nodeType: undefined,
                                    nodeIndex: undefined,
                                  }}
                                />
                                {(isSourceSubstep || isTargetPosition) && (
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      color: "#007bff",
                                      marginLeft: "10px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {/* {isSourceSubstep ? "(Moving)" : "(New Position)"} */}
                                  </span>
                                )}
                              </div>

                              <div style={{ whiteSpace: 'pre-wrap' }}>{substep.short_description}</div>

                              {/* Substep Rich Texts */}
                              {filteredItems.map((item, itemIndex) => {
                                switch (item.type) {
                                  case "richText": {
                                    const globalRichTextNumber =
                                      richTextCounter++; // ✅ use then increment
                                    // render richText block here
                                    const label = (
                                      <HeadingWithTreePath
                                        title={`Rich Text ${globalRichTextNumber}`}
                                        treePathParams={{
                                          sectionIndex: currentSectionIndex,
                                          stepIndex: globalStepNumber - 1,
                                          substepIndex: undefined,
                                          nodeType: "richText",
                                          nodeIndex: globalRichTextNumber - 1,
                                        }}
                                      />
                                    );

                                    return (
                                      <div
                                        key={item.rich_text_tree_node_id}
                                        style={{
                                          marginTop: "20px",
                                          clear: "both",
                                        }}
                                      >
                                        <label
                                          style={{
                                            display: "flex",
                                            gap: "6px",
                                            cursor: "pointer",
                                            clear: "both",
                                          }}
                                        >
                                          {label}
                                        </label>

                                        <div
                                          style={{
                                            marginLeft: "5px",
                                            marginTop: "-10px",
                                          }}
                                        >
                                          {item.short_description}
                                        </div>
                                        {item.category_data && (
                                          <div
                                            style={{
                                              marginLeft: "4px",
                                              marginTop: "10px",
                                              clear: "both",
                                            }}
                                          >
                                            {item.category_data.category_name}
                                          </div>
                                        )}
                                        <div
                                          style={{
                                            fontSize: "20px",
                                            marginLeft: "4px",
                                            marginTop: "5px",
                                            clear: "both",
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginTop: "-6px",
                                              clear: "both",
                                            }}
                                            dangerouslySetInnerHTML={{
                                              __html: item.rich_text_content,
                                            }}
                                          />
                                        </div>
                                      </div>
                                    );
                                  }
                                  case "video": {
                                    const globalVideoNumber = videoCounter++; // ✅ use then increment
                                    const label = (
                                      <HeadingWithTreePath
                                        title={`Video ${globalVideoNumber}`}
                                        treePathParams={{
                                          sectionIndex: currentSectionIndex,
                                          stepIndex: globalStepNumber - 1,
                                          substepIndex: undefined,
                                          nodeType: "video",
                                          nodeIndex: globalVideoNumber - 1,
                                        }}
                                      />
                                    );

                                    return (
                                      <div
                                        key={label}
                                        style={{
                                          marginTop: "20px",
                                          clear: "both",
                                        }}
                                      >
                                        <label
                                          style={{
                                            display: "flex",
                                            gap: "6px",
                                            cursor: "pointer",
                                            clear: "both",
                                          }}
                                        >
                                          {label}
                                        </label>

                                        {renderVideo(item)}

                                        <div>{item.video_url || ""}</div>

                                        <div>
                                          {item.short_description || ""}
                                        </div>
                                      </div>
                                    );
                                  }

                                  case "form": {
                                    const globalFormNumber = formCounter++; // ✅ use then increment
                                    const label = (
                                      <HeadingWithTreePath
                                        title={`Form ${globalFormNumber}`}
                                        treePathParams={{
                                          sectionIndex: currentSectionIndex,
                                          stepIndex: globalStepNumber - 1,
                                          substepIndex: undefined,
                                          nodeType: "form",
                                          nodeIndex: globalFormNumber - 1,
                                        }}
                                      />
                                    );
                                    // render form block here
                                    return (
                                      <div
                                        key={label}
                                        style={{ clear: "both" }}
                                      >
                                        <label
                                          style={{
                                            display: "flex",
                                            gap: "6px",
                                            cursor: "pointer",
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          {label}
                                        </label>
                                        <div>{item.short_description}</div>
                                      </div>
                                    );
                                  }
                                  case "canvas": {
                                    const pages = getPages(item);

                                    const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                                    const label = (
                                      <HeadingWithTreePath
                                        title={`Canvas ${globalCanvasNumber}`}
                                        treePathParams={{
                                          sectionIndex: currentSectionIndex,
                                          stepIndex: globalStepNumber - 1,
                                          substepIndex: substepIndex,
                                          nodeType: "canvas",
                                          nodeIndex: globalCanvasNumber - 1,
                                        }}
                                      />
                                    );
                                    const shapes = item.shapes || [];

                                    return (
                                      <div
                                        key={label}
                                        style={{
                                          marginTop: "40px",
                                          clear: "both",
                                        }}
                                      >
                                        <label
                                          style={{
                                            display: "flex",
                                            gap: "6px",
                                            cursor: "pointer",
                                            clear: "both",
                                          }}
                                        >
                                          {label}
                                        </label>

                                        <div>{item.short_description}</div>

                                        {/* Display all pages vertically */}
                                        <CanvasDisplay pages={pages} />
                                      </div>
                                    );
                                  }
                                  case "attachment": {
                                    const attachmentList =
                                      item.attachments || [];
                                    if (attachmentList.length === 0)
                                      return null;

                                    //  const globalAttachmentNumber =
                                    //           attachmentCounter++; // ✅ use then increment
                                    const globalAttachmentNumber =
                                      attachmentCounter++; // ✅ Increment here per attachment
                                    const label = (
                                      <HeadingWithTreePath
                                        title={`Attachment ${globalAttachmentNumber}`}
                                        treePathParams={{
                                          sectionIndex: currentSectionIndex,
                                          stepIndex: globalStepNumber - 1,
                                          substepIndex: substepIndex,
                                          nodeType: "attachment",
                                          nodeIndex: globalAttachmentNumber - 1,
                                        }}
                                      />
                                    );

                                    return (
                                      <div key={item} style={{ clear: "both" }}>
                                        <label
                                          style={{
                                            display: "flex",
                                            gap: "6px",
                                            cursor: "pointer",
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          {label}
                                        </label>
                                        <div>{item.short_description}</div>
                                        {attachmentList.map((attachment, i) => (
                                          <div
                                            key={i}
                                            style={{
                                              marginLeft: "20px",
                                              clear: "both",
                                            }}
                                          >
                                            {renderPreview(attachment)}
                                          </div>
                                        ))}
                                      </div>
                                    );
                                  }
                                  default:
                                    return null;
                                }
                              })}
                            </div>
                          );
                        })}
                      </div>
                    );
                  }
                )}
              </div>
            );
          })}
        </div>
      </div>
      {/* Remove old loader position */}
      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content_addsection">
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <h4
                style={{
                  marginLeft: "23px",
                  fontSize: "18px",
                  color: "#333333",
                }}
              >
                {location.state.movingSubstep
                  ? `${
                      createCopy ? "Confirm Copy" : "Confirm Move"
                    } of Substep ${sourceStepIndex + 1}${String.fromCharCode(
                      65 + sourceSubstepIndex
                    )} from Step ${sourceStepIndex + 1}`
                  : location.state.movingStep
                  ? `${createCopy ? "Confirm Copy" : "Confirm Move"} of Step ${
                      sourceStepIndex + 1
                    } ${
                      moveType === "up"
                        ? "Above"
                        : moveType === "into"
                        ? ""
                        : "Below"
                    } ${
                      moveType === "into"
                        ? `Section ${targetSectionIndex + 1}`
                        : `Step ${
                            targetSectionData?.globalStepNumber ||
                            targetSectionData?.stepIndex + 1 ||
                            location.state.targetStepIndex + 1
                          }`
                    }`
                  : `${
                      createCopy ? "Confirm Copy" : "Confirm Move"
                    } of Section ${sourceSectionIndex + 1} ${
                      moveType === "up" ? "Above" : "Below"
                    } Section ${targetSectionIndex + 1}`}
              </h4>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#666",
                }}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div
              style={{ padding: "24px", marginTop: "-28px", color: "#333333" }}
            >
              <h4 style={{ fontSize: "14px" }}>
                For {type} {partNumber} - Rev {revision}
              </h4>

              <p style={{ fontSize: "14px", color: "#333333" }}>
                <strong>Editor:</strong>{" "}
                <span style={{ marginLeft: "10px" }}>
                  {localStorage.getItem("user_name")}
                </span>
              </p>

              <label
                className="modal-label"
                style={{ fontSize: "14px", color: "#333333" }}
              >
                Comment<span className="required">*</span>
              </label>
              <textarea
                className="modal-textarea"
                placeholder="Enter your comments here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
                disabled={isModalLoading}
              ></textarea>
            </div>

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                padding: "16px 24px",
                borderTop: "1px solid #e0e0e0",
                marginTop: "-10px",
                position: "relative",
              }}
            >
              {isModalLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 10,
                  }}
                >
                  <div
                    className="loader-spinner"
                    style={{
                      border: "4px solid #f3f3f3",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      animation: "spin 1s linear infinite",
                      marginRight: "10px",
                    }}
                  ></div>
                  <span>Processing...</span>
                </div>
              )}
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#6c757d",
                  color: "#e9ecef",
                  cursor: isModalLoading ? "not-allowed" : "pointer",
                }}
                disabled={isModalLoading}
              >
                Close
              </button>
              <button
                onClick={handleConfirmSave}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  background: "#007bff",
                  color: "white",
                  cursor: isModalLoading ? "not-allowed" : "pointer",
                  opacity: isModalLoading ? 0.7 : 1,
                }}
                disabled={isModalLoading}
              >
                {isModalLoading ? "Processing..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProcedureSubstepMovePreview;
